module.exports = __webpack_public_path__ + "public/img/jindian.46167f83.png";